<template>


        <div :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'"
 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"    >
        <header  :class="$i18n.locale=='العربية'?'style__HeaderStyled-p8n03k-0 jRJGVj':'style__HeaderStyled-p8n03k-0 jQPPQ'">
            <div style="margin-top:1%;margin-left:1%;margin-right:1%" class="style__LogoStyled-sc-1k3y3hk-0 dmVjMF logo-holder">
                <a :href="$i18n.locale=='en'?'/en':$i18n.locale=='العربية'?'/ar':$i18n.locale=='Français'?'/fr/':$i18n.locale=='登陆'?'/ch':'/ru'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" >
                <img :src="this.logo==null?'https://dev.marketequityinc.com/public/public/225/20220524073700newlogo.png':this.serverurl+this.logo " />
            </a>
            </div>


            <div class="style__NavBarWrap-p8n03k-1 iMlrcz header-navbar" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" >

                <div :class="$i18n.locale=='العربية'?'style__LoginDropdown-p8n03k-5 bYfyqH':'style__LoginDropdown-p8n03k-5 kznenD'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'" >
                    <span :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;padding-left: 20px;text-align: left;' :'font-family: Comfortaa!important;padding-left: 20px;text-align: left;'"  > {{ $i18n.locale=='en'?'login':$i18n.locale=='العربية'?'تسجيل دخول':$i18n.locale=='中文'?'登陆':$i18n.locale=='Русский'?'Авторизоваться':"Connexion" }}
                   </span>
                    <ul class="style__NavBarStyled-sc-1q63mnp-0 bBwWlw" :style="this.$i18n.locale == 'Français'?'width: 190px;':'width: auto;'">
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">
                            <a :href="$i18n.locale=='中文'?'https://asportal.marketequityinc.com/':'https://portal.marketequityinc.com/Login'" target="_blank">{{ $i18n.locale == 'en' ? 'Client Login' : $i18n.locale == 'العربية' ? 'منطقة العملاء' : $i18n.locale == '中文' ? '客户后台' :$i18n.locale=='Русский'?'Вход для клиентов': 'Connexion client' }}</a>
                        </li>
                        <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">
                            <a :href="$i18n.locale=='中文'?'https://asportal.marketequityinc.com/':'https://portal.marketequityinc.com/Login'" target="_blank">{{ $i18n.locale == 'en' ? 'Partner Login' : $i18n.locale == 'العربية' ? 'منطقة الشركاء' : $i18n.locale == '中文' ? '代理后台':$i18n.locale=='Русский'?'Вход для партнеров' : 'Connexion partenaire'}}</a>
                        </li>
<!--                          <li class="style__NavItemStyled-sc-1qsj0rt-0 tUscN">-->
<!--                            <a :href="$i18n.locale=='中文'?'https://client.marketequityinc.com/':'https://client.marketequityinc.com/'" target="_blank">{{ $i18n.locale == 'en' ? 'Client Area' : $i18n.locale == 'العربية' ? 'منصة العميل' : $i18n.locale == '中文' ? '客户区':$i18n.locale=='Русский'?'Личный кабинет' : 'Espace client'}}</a>-->
<!--                        </li>-->
                    </ul>

                </div>
                 <span :style="$i18n.locale=='العربية'?'margin-top:10.5%':'margin-top:16%'"> <img style="width:25px;height:25px;"
                            src="https://frontend.marketequityinc.com/src/assets/images/langswitcher.png"/></span>

                <div :class="$i18n.locale=='العربية'?'style__LangSwitcher-p8n03k-4 gdsyDF':'style__LangSwitcher-p8n03k-4 frmeiJ'">

                    <div><span class="languageSelector" style="color: rgb(255, 255, 255);text-transform: uppercase;" >

	</span>

                        <ul class="language-list">
                            <li style="" class="style__LangSwitchItemStyled-b68vb-0 esasYI"
                                v-for="(lang, i) in langs"
                                :key="`lang-${i}`"
                                :value="lang">
                                <a @click="langchange(lang)" href="#">{{ lang }}</a>
                            </li>
                            <!--                            <li class="style__LangSwitchItemStyled-b68vb-0 esasYI"><a href="/ar">عربى</a><a href="https://cn.marketequityinc.com/zh/">中文</a></li>-->
                        </ul>

                    </div>
                </div>


                <div style="max-height: 47px;" id="menubtn" :class="$i18n.locale=='العربية'?'style__NavToggler-p8n03k-2 iIOxmM':'style__NavToggler-p8n03k-2 iIOxmM'">
                    <a style="text-decoration: none" href="#">
                        <span style="color:transparent">close</span>
                    </a>
                </div>

            </div>
            <div style="margin-top:10px!important;" v-if="this.mainmenus" id="megamenudiv"  :class="$i18n.locale=='العربية'?'style__MegaMenu-p8n03k-3 kQeCDJ':'style__MegaMenu-p8n03k-3 kpcXiD ltrclass'">
                <div  v-for="mainmenu  in mainmenus" :key="mainmenu.id" class="style__DropDownItemStyled-sc-1ndrbr9-0 ejBNec">
                    <h3 style="">{{ $i18n.locale=='en'?mainmenu.en_title:$i18n.locale=='العربية'?mainmenu.ar_title:$i18n.locale=='中文'?mainmenu.ch_title:$i18n.locale=='Русский'?mainmenu.ru_title:mainmenu.fr_title }}
                    </h3>

                    <ul   v-for="submenu  in submenus"  :key="submenu.id"  class="style__DropDownList-sc-1ndrbr9-1 eLdVbJ"  :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                         <li  v-if="submenu.parent_id==mainmenu.id && lanflag=='ar' && submenu.ar_title"  class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX" style="" >
                            <a  :class="pathname === submenu.name ? 'active' : ''" :href="'../../../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                        </li>
                         <li  v-if="submenu.parent_id==mainmenu.id && lanflag=='fr' && submenu.fr_title"  class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX" style="" >
                            <a  :class="pathname === submenu.name ? 'active' : ''" :href="'../../../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                        </li>
 <li  v-if="submenu.parent_id==mainmenu.id && lanflag=='ch' && submenu.ch_title"  class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX" style="" >
                            <a  :class="pathname === submenu.name ? 'active' : ''" :href="'../../../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                        </li>
                        <li  v-if="submenu.parent_id==mainmenu.id && lanflag=='en' && submenu.en_title"  class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX" style="" >
                            <a  :class="pathname === submenu.name ? 'active' : ''" :href="'../../../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                        </li>

                         <li  v-if="submenu.parent_id==mainmenu.id && lanflag=='ru' && submenu.ru_title"  class="style__DropDownLinks-sc-1ndrbr9-2 fctzjX" style="" >
                            <a  :class="pathname === submenu.name ? 'active' : ''" :href="'../../../../'+lanflag+'/'+submenu.name">{{ $i18n.locale=='en'?submenu.en_title:$i18n.locale=='العربية'?submenu.ar_title:$i18n.locale=='中文'?submenu.ch_title:$i18n.locale=='Русский'?submenu.ru_title:submenu.fr_title }}</a>
                        </li>


                    </ul>
                </div>

            </div>
<!--            <button class="style__CookieButtonStyled-r78o9j-0 ccZFZe">-->
<!--	<span>-->
<!--	<span>Cookies Policy</span>-->
<!--	</span>-->
<!--            </button>-->
            <div class="style__CookiesStyled-sc-1uvyyp8-0 hnbsQx">
                <div class="cc-message">
	<span class="close">
	</span>
                    <div>
                        <p>This website uses cookies to boost your experience. We'll assume you're pleased with this,
                            but you
                            will be able to opt-out if you would like. </p>
                        <div class="style__CookieBtn-sc-1uvyyp8-1 dOQskq">
                            <button class="btn-blk">Accept</button>
                            <a href="/en/privacy-and-security-policy">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
<!--          <div  v-if="tickerdata && $i18n.locale=='العربية'" class="tickerar" style="position: fixed;-->
<!--left: 0;-->
<!--bottom: 0;-->
<!--width: 100%;-->
<!--z-index: 4;direction: rtl">-->

<!--                <div  class="ticker__list" style="margin-right:-60%;animation-direction: reverse!important;-->
<!--" >-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[0].count1" ><strong>{{ tickerdata[0].Symbol }}</strong><span :class="'bid '+tickerdata[0].bidclass">{{ tickerdata[0].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[1].count1" ><strong>{{ tickerdata[1].Symbol }}</strong><span :class="'bid '+tickerdata[1].bidclass">{{ tickerdata[1].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[2].count1" ><strong>{{ tickerdata[2].Symbol }}</strong><span :class="'bid '+tickerdata[2].bidclass">{{ tickerdata[2].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[3].count1" ><strong>{{ tickerdata[3].Symbol }}</strong><span :class="'bid '+tickerdata[3].bidclass">{{ tickerdata[3].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[4].count1" ><strong>{{ tickerdata[4].Symbol }}</strong><span :class="'bid '+tickerdata[4].bidclass">{{ tickerdata[4].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[5].count1" ><strong>{{ tickerdata[5].Symbol }}</strong><span :class="'bid '+tickerdata[5].bidclass">{{ tickerdata[5].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[6].count1" ><strong>{{ tickerdata[6].Symbol }}</strong><span :class="'bid '+tickerdata[6].bidclass">{{ tickerdata[6].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[7].count1" ><strong>{{ tickerdata[7].Symbol }}</strong><span :class="'bid '+tickerdata[7].bidclass">{{ tickerdata[7].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[8].count1" ><strong>{{ tickerdata[8].Symbol }}</strong><span :class="'bid '+tickerdata[8].bidclass">{{ tickerdata[8].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[9].count1" ><strong>{{ tickerdata[9].Symbol }}</strong><span :class="'bid '+tickerdata[9].bidclass">{{ tickerdata[9].Bid }}</span></div>-->
<!--                    <div   :class="'ticker__item item-'+tickerdata[10].count1" ><strong>{{ tickerdata[10].Symbol }}</strong><span :class="'bid '+tickerdata[10].bidclass">{{ tickerdata[10].Bid }}</span></div>-->

<!--                </div>-->
<!--            </div>-->

<!--                <div v-if="tickerdata &&  $i18n.locale!='العربية'" class="ticker" style="position: fixed;-->
<!--left: 0;-->
<!--bottom: 0;-->
<!--width: 100%;-->
<!--z-index: 4;">-->

<!--                  <div   class="ticker__list" style="margin-left:30%" >-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[0].count1" ><strong>{{ tickerdata[0].Symbol }}</strong><span :class="'bid '+tickerdata[0].bidclass">{{ tickerdata[0].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[1].count1" ><strong>{{ tickerdata[1].Symbol }}</strong><span :class="'bid '+tickerdata[1].bidclass">{{ tickerdata[1].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[2].count1" ><strong>{{ tickerdata[2].Symbol }}</strong><span :class="'bid '+tickerdata[2].bidclass">{{ tickerdata[2].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[3].count1" ><strong>{{ tickerdata[3].Symbol }}</strong><span :class="'bid '+tickerdata[3].bidclass">{{ tickerdata[3].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[4].count1" ><strong>{{ tickerdata[4].Symbol }}</strong><span :class="'bid '+tickerdata[4].bidclass">{{ tickerdata[4].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[5].count1" ><strong>{{ tickerdata[5].Symbol }}</strong><span :class="'bid '+tickerdata[5].bidclass">{{ tickerdata[5].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[6].count1" ><strong>{{ tickerdata[6].Symbol }}</strong><span :class="'bid '+tickerdata[6].bidclass">{{ tickerdata[6].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[7].count1" ><strong>{{ tickerdata[7].Symbol }}</strong><span :class="'bid '+tickerdata[7].bidclass">{{ tickerdata[7].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[8].count1" ><strong>{{ tickerdata[8].Symbol }}</strong><span :class="'bid '+tickerdata[8].bidclass">{{ tickerdata[8].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[9].count1" ><strong>{{ tickerdata[9].Symbol }}</strong><span :class="'bid '+tickerdata[9].bidclass">{{ tickerdata[9].Bid }}</span></div>-->
<!--                        <div   :class="'ticker__item item-'+tickerdata[10].count1" ><strong>{{ tickerdata[10].Symbol }}</strong><span :class="'bid '+tickerdata[10].bidclass">{{ tickerdata[10].Bid }}</span></div>-->

<!--                    </div>-->
<!--                </div>-->
            </div>

</template>
<script>
import 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js';
import 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js';
import 'https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.18/jquery.touchSwipe.min.js';
</script>
<script>

export default {
    name: 'header',
    data() {
        return {
            langs: ['en', 'العربية', '中文', 'Français','Русский'], language: 'en',
            logo: null,
            sitetitleen: null,
            sitetitlear: null,
            sitetitlech: null,
            sitetitlefr: null,
            locale:'en',
            mainmenus:'',
            submenus:'',
            lanflag:'en',
            routeurl:'',
            pathname:'',
            host:location.host,
             tickerdata:'',
            olddata:'',
            newdata:'',
            bidClassName:''



        }
    },

   created() {
       // this.interval = setInterval(() => this.ticker(), 4000);


    },
    beforeMount() {

        this.loaddata();
        this.loadmenus();
        this.routeurl=window.location.pathname;

        var pathvalues=(this.$route.path).split("/");
        this.pathname=pathvalues[2];

        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'en') {
            this.$i18n.locale = 'en';
            this.lanflag='en';


          //  document.getElementById("fp-nav").className = "right";
              var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }



        }
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
            this.lanflag='ar';
           // document.getElementById("fp-nav").className = "left";
           //  document.getElementById("fp-nav").className = "right";
              var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الاسهم مفابل الفروقات و العملات الأجنبية و جميع الأسهم و السلع و المؤشرات. تضمن ماركت إكويتي منصة تداول آمنة و عالية الجودة");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الفوركس,تداول,نفط,CFD,CFDs,منصة تداول,العملات المشفرة,تجارة الفوركس,سوق الاسهم,الأسهم,البورصة,عملات رقمية,ب,الذهب,أسعار الذهب,اسعار الذهب,Mt4 trading,Mt5,تداول الذهب,تداول النفط,تداول الاسهم,اكويتي,فوركس,ماركت إكويتي,Market Equity,اونلاين,تعلم التداول,التداول اونلاين,Zoom meeting,اقتصاد,محفظة مالية,الإقتصاد,الدولار الامريكي,الباوند,سلع ,السلع,محاضرة,استثمار,شركة ماركت إيكويتي");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }




        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
            this.lanflag='ch';
           // document.getElementById("fp-nav").className = "right";

            var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
            this.lanflag='fr';
           // document.getElementById("fp-nav").className = "right";
           var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }

        }
         if (pathvalues[1] == 'ru') {
            this.$i18n.locale = 'Русский';
            this.lanflag='ru';
           // document.getElementById("fp-nav").className = "right";
           var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }

        }

        // this.$i18n.locale=pathvalues[1];
        this.pagenameroute = pathvalues[2];
      //  this.ticker();

    },

    methods: {
            //       ticker(){

            // // var oldData = null;
            // // var newData =null;

            // var data = null;
            // //setInterval(initAjax, 10000);

            // this.$axios.get("loadtickerdata",
            // )
            //     .then(response => {

            //         var result = response;
            //         data = result.data.data.data;

            //         this.olddata = this.newdata;
            //         this.newdata = data;

            //       // this.tickerdata=null;
            //         this.tickerdata=data;

            //         console.log(data)

            //         for(var i = 0; i < data.length; i++){

            //             if(this.olddata){


            //                 this.tickerdata[i]['bidclass'] = data[i].Bid < this.olddata[i].Bid ? 'low' :  'high';

            //             }

            //             // alert(data[i].Symbol)
            //             // this.$refs('itemticker-'+(i+1)).html('<strong>'+data[i].Symbol+'</strong><span>'+data[i].Bid+'</span>');
            //         }
            //         // alert(this.olddata)
            //         // var html = '';

            //     });




            // var ticker = document.querySelector('.ticker')
            //     , list = document.querySelector('.ticker__list')
            //     , clone = list.cloneNode(true)
            //
            // ticker.append(clone)


     //  },


        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                        this.logo = res.data.sitesettings[0].logo;
                        this.sitetitleen = res.data.sitesettings[0].sitetitleen;
                        this.sitetitlear = res.data.sitesettings[0].sitetitlear;
                        this.sitetitlefr = res.data.sitesettings[0].sitetitlefr;
                        this.sitetitlech = res.data.sitesettings[0].sitetitlech;

                    }
                });
        },
        loadmenus() {

            this.$axios.get("loadmenus",
            )
                .then(res => {
                    if (res) {

                        this.mainmenus = res.data.mainmenus;
                        this.submenus = res.data.submenus;


                    }
                });
        },
        langchange(lang) {
           this.$i18n.locale=lang;
            if (lang == 'en') {
                document.title = this.sitetitleen;
                document.dir = "ltr";
                this.lanflag='en';
                 document.getElementById("fp-nav").className = " right";
               document.getElementById("chinesechat").style.display="none";
                //document.getElementById('chinesechat').style.visibility="hidden";
               // document.getElementById("nochinese").style.display="block";
                document.getElementById("englishchat").style.display="block";

                //document.getElementById('chinesechat').style.visibility="hidden";
                document.getElementById("arabicchat").style.display="none";
                var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }



            }
            if (lang == 'العربية') {

                document.title = this.sitetitlear;
                document.dir = "rtl";
                this.lanflag='ar';

                  var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الاسهم مفابل الفروقات و العملات الأجنبية و جميع الأسهم و السلع و المؤشرات. تضمن ماركت إكويتي منصة تداول آمنة و عالية الجودة");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الفوركس,تداول,نفط,CFD,CFDs,منصة تداول,العملات المشفرة,تجارة الفوركس,سوق الاسهم,الأسهم,البورصة,عملات رقمية,ب,الذهب,أسعار الذهب,اسعار الذهب,Mt4 trading,Mt5,تداول الذهب,تداول النفط,تداول الاسهم,اكويتي,فوركس,ماركت إكويتي,Market Equity,اونلاين,تعلم التداول,التداول اونلاين,Zoom meeting,اقتصاد,محفظة مالية,الإقتصاد,الدولار الامريكي,الباوند,سلع ,السلع,محاضرة,استثمار,شركة ماركت إيكويتي");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }
            }
            if (lang == '中文') {
                document.dir = "ltr";
                document.title = this.sitetitlefr;
                this.lanflag='ch';
                document.getElementById("fp-nav").className = " right";
                document.getElementById("chinesechat").style.display="block";
               document.getElementById("englishchat").style.display="block";

                //document.getElementById('chinesechat').style.visibility="hidden";
                document.getElementById("arabicchat").style.display="none";
                var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }



            }
            if (lang == 'Français') {
                document.dir = "ltr";
                document.title =this.sitetitleen;
                this.lanflag='fr';
                document.getElementById("fp-nav").className = " right";
                document.getElementById("chinesechat").style.display="none";
              document.getElementById("englishchat").style.display="block";
                document.getElementById("arabicchat").style.display="none";
                var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                var imageMeta = document.createElement('meta');
                imageMeta.setAttribute('property', 'og:image');
                imageMeta.content = 'https://dev.marketequityinc.com/public/public/225/20220524073700newlogo.png';
                document.getElementsByTagName('head')[0].appendChild(imageMeta);
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }
                }

                            if (lang == 'Русский') {
                document.dir = "ltr";
                document.title =this.sitetitleen;
                this.lanflag='ru';
                document.getElementById("fp-nav").className = " right";
                document.getElementById("chinesechat").style.display="none";
              document.getElementById("englishchat").style.display="block";
                document.getElementById("arabicchat").style.display="none";
                var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }
                }

        }
    }

}


</script>
<style>
.rightalign{
    float:left!important;
}.leftalign{
    float:left!important;
}
.rtlclass{
    direction: rtl!important;
    left:0!important;


}
.ltrclass{
    direction: ltr!important;
}
kpcXiD > div ul li a:hover::before, .kpcXiD > div ul li a.active::before {

    top: 6px!important;
    width:10px!important;
    height:10px!important;
}
.kpcXiD > div ul li a:hover::after, .kpcXiD > div ul li a.active::after {

    top: 10px!important;
    width:10px!important;


}pcXiD > div ul li a:hover::before, .kpcXiD > div ul li a::before {

     top: 6px!important;
     width:10px!important;
     height:10px!important;
}
.kpcXiD > div ul li a:hover::after, .kpcXiD > div ul li a::after {

    top: 10px!important;
    width:10px!important;

}

kQeCDJ > div ul li a:hover::before, .kQeCDJ  > div ul li a.active::before {

    top: 6px!important;
    width:10px!important;
    height:10px!important;
}
.kQeCDJ > div ul li a:hover::after, .kQeCDJ > div ul li a.active::after {

    top: 10px!important;
    width:10px!important;


}kQeCDJ > div ul li a:hover::before, .kQeCDJ > div ul li a::before {

     top: 6px!important;
     width:10px!important;
     height:10px!important;
 }
.kQeCDJ > div ul li a:hover::after, .kQeCDJ > div ul li a::after {

    top: 10px!important;
    width:10px!important;

}
bYfyqH span {

    padding-left: 0px;
    margin-left: -73px!important;
}
.ticker,.tickerar {
    display: flex;
    background: #000;
    color: #fff;
}
.ticker__list {
    display: flex;
    animation: ticker 15s infinite linear;
    cursor:pointer;
}
.ticker:hover .ticker__list,.tickerar:hover .ticker__list {
    animation-play-state: paused;
}
.ticker__item {
    margin-right: 40px;
    display: flex;
    position: relative;
    width:12rem;
}
.ticker__item:hover{
    background: #1d1d1d;
}
.ticker__item:after{
    content:"";
    position:absolute;
    width:1px;
    background:#26a7c7;
    height:20px;
    right:0;
    top:50%;
    transform:translateY(-50%);
}
.ticker__item span, .ticker__item strong{
    display: inline-block;
    margin-right: 10px;
    white-space:nowrap;
    position:relative;
    padding: 10px;
}
.ticker__item strong{
    padding-left: 0;
    padding-right: 0;
}
.ticker__item span{
    padding-right: 23px;
}
.low{
    background: rgba(244,67,54, 0.28);
    transition:background  linear .3s;
}
span.high:after,
span.low:after{
    position:absolute;
    right:10px;
    top:50%;
    transform:translateY(-50%);
}
span.low:after{
    content:" ";
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #f00;
}
.high{
    background: rgba(0, 150, 136, 0.28);
    transition:background  linear .3s;
}
span.high:after{
    content:" ";
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #0f0;
}
span.high ,
span.low {
    position:relative;
}
@-moz-keyframes ticker {
    100% {
        transform: translateX(-100%);
    }
}
@-webkit-keyframes ticker {
    100% {
        transform: translateX(-100%);
    }
}
@-o-keyframes ticker {
    100% {
        transform: translateX(-100%);
    }
}
@keyframes ticker {
    100% {
        transform: translateX(-100%);
    }
}
.language-list{
    min-width:78px!important;
}

</style>

